import React from 'react';
import MessagingRouter from '../../Messaging.router';
import MessagingProvider from '../../providers/Messaging';

const MessagingGlobalWrapper: React.FC = () => {
  return (
    <MessagingProvider>
      <MessagingRouter />
    </MessagingProvider>
  );
};

export default MessagingGlobalWrapper;
